import React, { useState, useEffect } from "react";
import DateTimeDisplay from "./DateTimeDisplay";
import { useCountdown } from "./hooks/useCountdown";
import { Box, Container, Grid2, Stack, Typography } from "@mui/material";
const ExpiredNotice = () => {
  return (
    <Container fluid style={{ padding: "5%" }}>
      <ShowCounter months={0} days={0} hours={0} minutes={0} seconds={0} />
    </Container>
  );
};

const ShowCounter = ({ months, days, hours, minutes, seconds }) => {

  return (
    <Box>
      <Grid2
        style={{
          width: '100%'
        }}
        container
        textAlign='center'
        justifyContent='center'
        spacing={5}
      >
        <Grid2 size={{ xs: 2, md: 2, lg: 2 }} style={{ textAlign: 'center' }}>
          <DateTimeDisplay value={months} type={"MESES"} isDanger={false} />
        </Grid2>
        <Grid2 size={{ xs: 2, md: 2, lg: 2 }} style={{ textAlign: 'center' }}>
          <DateTimeDisplay value={days} type={"DIAS"} isDanger={false} />
        </Grid2>
        <Grid2 size={{ xs: 2, md: 2, lg: 2 }} style={{ textAlign: 'center' }}>
          <DateTimeDisplay value={hours} type={"HORAS"} isDanger={false} />
        </Grid2>
        <Grid2 size={{ xs: 2, md: 2, lg: 2 }} style={{ textAlign: 'center' }}>
          <DateTimeDisplay value={minutes} type={"MINUTOS"} isDanger={false} />
        </Grid2>
        <Grid2 size={{ xs: 2, md: 2, lg: 2 }} style={{ textAlign: 'center' }}>
          <DateTimeDisplay value={seconds} type={"SEGUNDOS"} isDanger={false} />
        </Grid2>
      </Grid2>
    </Box>
  );
};

const CountdownTimer = ({ targetDate, finishTrigger }) => {
  const [months, days, hours, minutes, seconds] = useCountdown(targetDate);
  const [bandera, setBandera] = useState(false);
  useEffect(() => {
    if (!bandera) {
      setBandera(true);
    } else {
      if (days + hours + minutes + seconds <= 0) {
        finishTrigger()
          .then(() => { })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [months, days, hours, minutes, seconds]);

  if (months + days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <Stack spacing={10}>
        <Typography style={{ textAlign: "center", color: '#103468' }} variant="h4">¡Ya nos estamos preparando para la gran fecha! Faltan:</Typography>
        <ShowCounter
          months={months}
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
        /></Stack>

    );
  }
};

export default CountdownTimer;
